import { z } from "zod";
import { DmaSettingParameterKind } from "./dma-setting-parameter-kind.schema";
export const dmaSettingNumberParameterDtoSchema = z.object({
    kind: z.literal(DmaSettingParameterKind.Number),
    name: z.string(),
    value: z.number(),
});
